
  import Vue from "vue";
  import { NewCompaniesApiFunc, setAccessToken } from "@/api";
  import { Company } from "@/models";

  import TheTemplate from "../TheNoSidebarTemplate.vue";
  import CompanyList from "./components/CompanyList.vue";
  import SearchForm from "@/components/BaseSearchForm.vue";
  import Pager from "@/components/BasePager.vue";

  export type FilterCondition = {
    word?: string;
  };

  export type DataType = {
    companies: Array<Company>;
    filterCondition: FilterCondition;
    totalPage: number;
    currentPage: number;
  };

  export default Vue.extend({
    name: "CompanyListScreen",

    data(): DataType {
      return {
        companies: [],
        filterCondition: {
          word: ""
        },
        totalPage: 0,
        currentPage: 0
      };
    },

    components: {
      TheTemplate,
      SearchForm,
      CompanyList,
      Pager
    },

    mounted() {
      this.fetchCompanies();
    },

    watch: {
      $route(to, from) {
        if (to.params.updated === "true") {
          this.fetchCompanies(this.currentPage);
        }
      }
    },

    methods: {
      async fetchCompanies(page?: number): Promise<void> {
        const filterString: string = JSON.stringify({
          q: this.filterCondition.word
        });
        setAccessToken(this.$auth.accessToken);
        const { data, err } = await NewCompaniesApiFunc().adminListCompanies(
          filterString,
          page
        );

        if (err != null) {
          this.$handleApiError(err, () => {
            this.fetchCompanies(page);
          });
          return;
        }

        this.companies = data.list;
        this.currentPage = data.currentPage;
        this.totalPage = data.totalPage;
      },

      updateFilterCondition(condition?: FilterCondition): void {
        this.filterCondition = Object.assign(this.filterCondition, condition);
      },

      changePage(page: number): void {
        this.fetchCompanies(page);
      }
    }
  });
